import { blog as config } from "~/config/blog";
import fetchJson from "~/utils/Fetch/json";

export const getTag = ({ slug, id }) => {
  let base = "tags/";
  if (id) {
    base += `${id}/`;
  }

  if (slug) {
    base += `slug/${slug}`;
  }

  const url = config.url(base);
  return fetchJson(url);
};

export const getUrl = (tag) => {
  return `${config.baseUrl}${tag?.slug}`;
};
